//@flow
import React from 'react';
import aes from 'crypto-js/aes';
import encb64 from 'crypto-js/enc-base64';
import enchex from 'crypto-js/enc-hex';
import encutf8 from 'crypto-js/enc-utf8';

export default class VMUtil {
	static getButtonLabel = (
		button: Object,
		products: Array<Object> = [],
		defaultValue?: any
	) => {
		const productID = button.buttonID;
		const slavePattern =
			button.slavePattern === undefined ? null : button.slavePattern;
		const product = products.find(
			(product) =>
				product.productID === productID && product.slavePattern === slavePattern
		);
		if (!product) {
			return defaultValue ? defaultValue : null;
		}

		return (
			<>
				{product.name}
				<br />
				{product.price} {product.currency}
			</>
		);
	};

	/*
		These functions are not part of the system main security, they are only here for preventing the user
		to cleary see their machine's id in the system. So they would not see an url like http://address/#/vms/10/detailer
		
		Important! The following functions are also available on the frontend!
  	*/
	static secretPhrase = 'QQ51QR7EMEH380R0B29PR2K5D38ZUJRH9CL80TBP';

	static encodeVMID = (vmID) => {
		let b64 = aes.encrypt(vmID.toString(), VMUtil.secretPhrase).toString();
		var e64 = encb64.parse(b64);
		var eHex = e64.toString(enchex);
		return eHex;
	};

	static decodeVMID = (encrpyted) => {
		let reb64 = enchex.parse(encrpyted);
		let bytes = reb64.toString(encb64);
		let decrypt = aes.decrypt(bytes, VMUtil.secretPhrase);
		let plain = decrypt.toString(encutf8);
		return plain;
	};

	static getMachineStateIdFromString = (stateString) => {
		switch (stateString.toLowerCase()) {
			case 'operational':
				return 0;
			case 'ok':
				return 0;
			case 'programming':
				return 1;
			case 'warning':
				return 2;
			case 'error':
				return 3;
			default:
				break;
		}
	};

	static getMachineStateStringFromID = (stateID) => {
		const machineStates = ['ok', 'programming', 'warning', 'error'];
		return stateID || stateID == 0 ? machineStates[stateID] : 'undefined';
	};

	static MachineTypes = {
		UNKNOWN: 0,
		ASTRO: 1,
		VENEZIA: 2,
		SNAKKYMAX: 3,
		ZETA: 4,
		SPAZIO: 5,
		KIKKO: 6,
		KIKKOMAX: 7,
		SNAKKY: 8,
		WURLITZER: 9,
		ASTROP: 10,
		ZENITH: 11,
		BVM971: 12,
		CANTO: 13,
		GROUP500: 14,
		LUCE_18_2: 15,
		QUARZO500: 16,
		LUCE_12_2: 17,
		DUCALECITY: 18,
		VENEZIAPLUS: 19,
		SAGOMALEAN: 20,
		CAFFEEUROPA: 21,
		LUCE_12: 22,
		LAZIO: 23,
		LUCE_18: 24,
		LAZIO_18: 25,
		LUCE_PORTOFINO: 26,
		SPAZIORD: 27,
		SPAZIOPLUS: 28,
		LAZIO_18_3: 29,
		KLIXOUTLOOK: 30,
		BVM972: 31,
		JEDELYNX: 32,
		BRIO3: 33,
		ANTARES_TROLL: 34,
		SOLISTA: 35,
		KLIX900: 36,
		RHEA_XM: 37,
		LUCE_X2: 38,
		SIELAFF_FK185: 39,
		LUCE_600: 40,
		SNAKKYMINI: 41,
		ANTARES_BVM: 42,
		INFORMATIVE_COMPATIBILITY: 43,
		COLIBRI: 44,
		ASTRO_ALPHANUMERIC: 45,
		BRIO_200: 46,
		AZKOYEN: 47
	};

	static decodeLCDLine = (hex, machineType) => {
		
		let isInverted = false;

		let str = '';
		let invertedMap = [];

		const machinesWithInvertedCharacters = [
			VMUtil.MachineTypes.CANTO,
			VMUtil.MachineTypes.SOLISTA
		];

		for (var i = 0; i < hex.length; i += 2) {
			// Replace the some characters, given by zsolt
			const currentCharacterValue = parseInt(hex.substr(i, 2), 16);
			let tc = String.fromCharCode(currentCharacterValue);

			switch (currentCharacterValue) {
				case 0x01:
					
					if (machinesWithInvertedCharacters.includes(machineType)) {
						tc='';
						isInverted = false;
					}
					if (
						machineType == VMUtil.MachineTypes.KLIXOUTLOOK ||
						machineType == VMUtil.MachineTypes.KLIX900
					) {
						tc = '↓';
					}
					if (machineType == VMUtil.MachineTypes.JEDELYNX) {
						tc = '↑';
					}

					break;
				case 0x02:					
					if (machinesWithInvertedCharacters.includes(machineType)) {
						tc='';
						isInverted = true;
					}
					if (
						machineType == VMUtil.MachineTypes.KLIXOUTLOOK ||
						machineType == VMUtil.MachineTypes.KLIX900
					) {
						tc = '»';
					}
					if (machineType == VMUtil.MachineTypes.JEDELYNX) {
						tc = '↓';
					}
					break;
				case 0x03:
					if (
						machineType == VMUtil.MachineTypes.KLIXOUTLOOK ||
						machineType == VMUtil.MachineTypes.KLIX900
					) {
						tc = '«';
					}
					if (machineType == VMUtil.MachineTypes.JEDELYNX) 						
						{tc = 'ä'
						};
					break;
				case 0x1f:
					if (machinesWithInvertedCharacters.includes(machineType)) {
						tc = 0x0a;
						break;
					}
				case 0x04:
					if (
						machineType == VMUtil.MachineTypes.KLIXOUTLOOK ||
						machineType == VMUtil.MachineTypes.KLIX900
					)
						tc = 'ℹ';
					break;
				case 0x05:
					if (machineType == VMUtil.MachineTypes.JEDELYNX) tc = '→';
					break;
				case 0x1c:
					invertedMap.push(isInverted);
					tc = '●';
					break;
				case 0x1d:
					invertedMap.push(isInverted);
					tc = '○';
					break;

				case '@':
					if (
						machineType == VMUtil.MachineTypes.BVM931 ||
						machineType == VMUtil.MachineTypes.BVM931_NUMERIC ||
						machineType == VMUtil.MachineTypes.BVM971 ||
						machineType == VMUtil.MachineTypes.BVM971_NUMERIC ||
						machineType == VMUtil.MachineTypes.BVM972 ||
						machineType == VMUtil.MachineTypes.BVM972_NUMERIC
					)
						tc = '●';
					break;
				case 0x7e:
					if (
						machineType == VMUtil.MachineTypes.SIELAFF_FK185 ||
						machineType == VMUtil.MachineTypes.SIELCUP
					)
						tc = '→';
					break;
				case 0x7f:
					if (
						machineType == VMUtil.MachineTypes.SIELAFF_FK185 ||
						machineType == VMUtil.MachineTypes.SIELCUP
					)
						tc = '←';
					break;
				case 0x80:
					if (
						machineType == VMUtil.MachineTypes.CANTO ||
						machineType == VMUtil.MachineTypes.SOLISTA ||
						machineType == VMUtil.MachineTypes.OPERA ||
						machineType == VMUtil.MachineTypes.CONCERTO
					)
						tc = '€';
					break;
				case 0x84:
					if (
						machineType == VMUtil.MachineTypes.SOLISTA ||
						machineType == VMUtil.MachineTypes.CONCERTO
					)
						tc = 'ä';
					break;
				case 0x8e:
					if (
						machineType == VMUtil.MachineTypes.SOLISTA ||
						machineType == VMUtil.MachineTypes.CONCERTO
					)
						tc = 'Ä';
					break;
				case 0x94:
					if (machineType == VMUtil.MachineTypes.SPAZIOPLUS) tc = 'ö';
					break;
				case 0x9a:
					if (machineType == VMUtil.MachineTypes.SPAZIOPLUS) tc = 'Ü';
					break;
				case 0xdf:
					if (
						machineType == VMUtil.MachineTypes.SNAKKY ||
						machineType == VMUtil.MachineTypes.MINISNAKKY ||
						machineType == VMUtil.MachineTypes.SAMBA ||
						machineType == VMUtil.MachineTypes.SNAKKYMAX
					)
						tc = '°';
					break;
				case 0xe1:
					if (
						machineType == VMUtil.MachineTypes.KLIXOUTLOOK ||
						machineType == VMUtil.MachineTypes.KLIX900
					)
						tc = 'ä';
					if (
						machineType == VMUtil.MachineTypes.SIELAFF_FK185 ||
						machineType == VMUtil.MachineTypes.SIELCUP
					)
						tc = 'Ä';
					break;
				case 0xe2:
					if (
						machineType == VMUtil.MachineTypes.KLIXOUTLOOK ||
						machineType == VMUtil.MachineTypes.KLIX900
					)
						tc = 'ß';
					break;
				case 0xed:
					if (
						machineType == VMUtil.MachineTypes.SIELAFF_FK185 ||
						machineType == VMUtil.MachineTypes.SIELCUP
					)
						tc = '£';

					break;
				case 0xef:
					if (
						machineType == VMUtil.MachineTypes.SIELAFF_FK185 ||
						machineType == VMUtil.MachineTypes.SIELCUP
					)
						tc = 'Ö';
					break;
				case 0xf5:
					if (
						machineType == VMUtil.MachineTypes.KLIXOUTLOOK ||
						machineType == VMUtil.MachineTypes.KLIX900
					)
						tc = 'ü';
					if (
						machineType == VMUtil.MachineTypes.SIELAFF_FK185 ||
						machineType == VMUtil.MachineTypes.SIELCUP
					)
						tc = 'Ü';
					break;
				case 0xf8:
					if (
						machineType == VMUtil.MachineTypes.CANTO ||
						machineType == VMUtil.MachineTypes.SOLISTA ||
						machineType == VMUtil.MachineTypes.CONCERTO ||
						machineType == VMUtil.MachineTypes.KORO ||
						machineType == VMUtil.MachineTypes.BRIOUP
					)
						tc = '°';
					break;
				case 0xfc:
					tc = '●';
					break;
				case 0xfd:
					tc = '○';
					break;
				default:
					break;
			}
			str += tc;
			invertedMap.push(isInverted);
		}		
		return { line: str, invertedMap };
	};
}
